<template>
	<div id="profile">
		<div class="row">
			<div class="col-12 col-md-3" >
				<!-- User Info Sidebar -->
				<div class="user-info-sidebar">
					<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
						<div class="fileinput-button avatarContact" style="text-align:center;">
							<div id="avatarContact" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="avatar img-circle img-responsive" style="position:relative;" :style="{ backgroundImage: 'url(' + (user.Params.avatar ? user.Params.avatar : default_avatar) + ')' }">
								<div id="avatarSpinner" style="position:absolute;top:24px;left:24px;" v-if="isSaving"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
								<input type="file" multiple id="avatarContactInput" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
							</div>
						</div>
					</form>
				</div>
			</div>

			<div class="col-12 col-md-9">
				<div class="row">
				<!-- User Contact form -->
				<!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
				<input style="display:none" type="text" name="fakeemailremembered"/>
				<input style="display:none" type="password" name="fakepasswordremembered"/>
				<input name="id" id="id" type="hidden"  v-model="user.id">
				<div class="col-12 card">
					<el-form ref="contactForm" label-position="top" :model="contact" :rules="contactrules" label-width="120px" @submit.native.prevent >
						<div class="card-header bg-primary details"><h5>Contact Information</h5></div>
						<div class="card-body" >
							<div class="row">
				                <el-form-item label="First Name" prop="FirstName"
	                                :rules="[{ required: true, message: 'First Name is required', trigger: 'blur'}]"
	                            >
	                                <el-input  size="default" v-model="contact.FirstName">
	                                </el-input>
	                            </el-form-item>
				                <el-form-item label="Last Name" prop="LastName"
	                                :rules="[{ required: true, message: 'Last Name is required', trigger: 'blur'}]"
	                            >
	                                <el-input size="default" v-model="contact.LastName">
	                                </el-input>
	                            </el-form-item>
								<el-form-item label="Primary Email" prop="EmailAddress"
									:rules="[{ required: true, message: 'Primary Email is required', trigger: 'blur'},
											 { type: 'email',  message: 'Primary Email is invalid', trigger: 'blur'}]"
								>
									<el-input  size="default" v-model="contact.EmailAddress" @change="emailSync">
									</el-input>
								</el-form-item>
								<el-form-item label="Work Phone" prop="Params.WorkPhoneNumber">
									<div class="el-form-item__content">
										<div class="el-input el-input--small el-input__wrapper">
											<input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="contact.Params.WorkPhoneNumber" />
										</div>
									</div>
								</el-form-item>
								<el-form-item label="Mobile" prop="Params.CellPhoneNumber">
									<div class="el-form-item__content">
										<div class="el-input el-input--small el-input__wrapper">
											<input autocomplete="off" class="el-input__inner" type="tel" v-maska="'(###) ###-####'" v-model="contact.Params.CellPhoneNumber" />
										</div>
									</div>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>

				<div class="card LoginDetails mt-4" style="width: 100%;">
					<el-form ref="userForm" label-position="top" :model="user" :rules="userrules" label-width="120px" @submit.native.prevent >
						<div class="card-header bg-primary details"><h5>Change Password</h5></div>
						<div class="card-body">
							<div>
								<el-form-item label="Current Password" prop="CurrPassword" >
									<el-input  size="default" type="password" v-model="user.CurrPassword"></el-input>
								</el-form-item>
								<el-form-item label="New Password" prop="NewPassword">
									<el-input  size="default" type="password" v-model="user.NewPassword"></el-input>
								</el-form-item>
								<el-form-item label="Confirm Password" prop="CnfmPassword">
									<el-input  size="default" type="password" v-model="user.CnfmPassword"></el-input>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
			</div>
			<div class="row" >
                <div class="col-12 text-center">
                    <button class="btn btn-success btn-icon" @click="saveProfile"  style="margin-right: 10px;">
                        <i class="fas fa-check"></i> <span> Save Changes</span>
                    </button>
                    <button class="btn btn-icon btn-dark cancel"  @click="reset(true)" >
                        <i class="fas fa-times"></i>  <span>Cancel</span>
                    </button>
                </div>
            </div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios'
	import { vMaska } from "maska/vue"

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		directives: { maska: vMaska },
		data () {
			var validateCurrPassword = (rule, value, callback) => {
				if (typeof value === 'undefined' || value == '') {
					if (this.user.NewPassword || this.user.CnfmPassword) {
						callback(new Error('Current Password is Required'));
					}
				} else {
					callback();
				}
			};
			var validateNewPassword = (rule, value, callback) => {
				if (typeof value === 'undefined' || value == '') {
					if (this.user.CurrPassword || this.user.CnfmPassword) {
						callback(new Error('New Password is Required'));
					}
				} else {
					if (this.config.Params.passwordMinLength && value.length < this.config.Params.passwordMinLength) {
						callback(new Error('Minimum Password length is ' +this.config.Params.passwordMinLength));
					} else if (this.config.Params.passwordRequireNumber == 'y' && !value.match(/\d+/g)) {
						callback(new Error('Must contain at least one number'));
					} else if (this.config.Params.passwordRequireUpper == 'y' && !value.match(/[A-Z]+/g)) {
						callback(new Error('Must contain at least one Upper Case Letter'));
					} else if (this.user.CnfmPassword !== '') {
				        this.$refs.userForm.validateField('CnfmPassword');
					}
					callback();
				}
			};
			var validateCnfmPassword = (rule, value, callback) => {
				if (typeof value === 'undefined' || value == '') {
					if (this.user.CurrPassword || this.user.NewPassword) {
						callback(new Error('Confirm Password is Required'));
					}
				} else if (value !== this.user.NewPassword) {
					callback(new Error('New and Confirm Passwords must match'));
				} else {
					callback();
				}
			};
			var validatePhoneNumber = (rule, value, callback) => {
				if (value) {
					if (value.length != 14) {
						callback(new Error('Phone Number must be 10 numbers'));
					} else {
						callback();
					}
				} else {
					callback();
				}
			};

			return {
				loading: true,
				uploadedFiles: [],
				uploadError: null,
				currentStatus: 0,
				uploadFieldName: 'photos',
				user : {UserLoginID : 0, EmailAddress: '', LoginRoleID: 0, NewPassword: '', CnfmPassword: '', Params : {}},
				contact : {"Params" : {}},
				OrigData: {},
				SystemTextID: '',
				contactrules: {
                    'Params.WorkPhoneNumber': [
                         { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                    'Params.CellPhoneNumber': [
                         { validator: validatePhoneNumber, trigger: 'blur' }
                    ],
                },
				userrules: {
                    CurrPassword: [
                        { validator: validateCurrPassword, trigger: 'blur' }
                    ],
                    NewPassword: [
                        { validator: validateNewPassword, trigger: 'blur' }
                    ],
                    CnfmPassword: [
                        { validator: validateCnfmPassword, trigger: 'blur' }
                    ]
                },
			}
		},
		name: 'Profile',
	    props: {
	        config : { type: Object }
	    },
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
            default_avatar () {
                return require('../images/default_avatar.png')
            },
            passwordMessage () {
				var msg = 'Passwords must be at least ' + this.config.Params.passwordMinLength + ' digits long. ';
				if (this.config.Params.passwordRequireUpper == 'y') {
					msg += 'Passwords must contain at least one UPPER case letter. ';
				}
				if (this.config.Params.passwordRequireNumber == 'y') {
					msg += 'Passwords must contain at least one Number. ';
				}
				return msg;
            },
		},
		methods: {
			reset(showMessage) {
				// reset form to initial state
				this.currentStatus = STATUS_INITIAL;
				this.uploadedFiles = [];
				this.uploadError = null;
				if (showMessage) {
					this.getProfileData();
					this.$notify({
						title: 'Success',
						message: "Profile has been reset",
						type: 'success',
						duration: 1500,
						showClose: false
					});
				 }
			},
			emailSync () {
				this.user.EmailAddress = this.contact.EmailAddress;
			},
			uploadAvatar(formData) {
				if (this.currentStatus == STATUS_SAVING) {
                    return true;
                }
				// upload data to the server
				this.currentStatus = STATUS_SAVING;
				axios.post('/users/uploadavatar', formData,
					{ headers: { 'Content-Type': 'multipart/form-data'} }
					)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_SUCCESS;
							this.user.Params.avatar = response.data.url;
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
						document.getElementById("avatarContactInput").value = "";
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
				});
			},
			filesChange(fieldName, fileList) {
				// handle file changes
				const formData = new FormData();

				if (!fileList.length) return;

				// append the files to FormData
				Array
					.from(Array(fileList.length).keys())
					.map(x => {
						formData.append(fieldName, fileList[x], fileList[x].name);
					});

				// save it
				this.uploadAvatar(formData);
			},
			getProfileData () {
				axios.post('/users/get', {'UserLoginID': this.currentUser.UserLoginID },
				)
				.then(response => {
					if (response.data.result == 'success') {
						this.user = response.data.user;
						this.contact = response.data.contact;
						this.setCountry(this.contact.Params.StateOrProvinceCodeID);
						this.getTeams();
					} else {
					}
				}).catch(response => {
				});
			},
			saveProfile () {
				var execSave = false;
				this.$refs['contactForm'].validate((valid) => {
                    if (valid) {
                        execSave = true;
					} else {
						//scroll to errors
						setTimeout(() => {document.querySelector("#profile .is-error").scrollIntoView(); }, 250);
					}
				});
                if (this.$refs['userForm']) {
	                this.$refs['userForm'].validate((valid) => {
	                     if (!valid) {
	                         execSave = false;
	                     }
	                });
                }
                if (execSave) {
					if (this.currentStatus == STATUS_SAVING) {
						return true;
					}
					this.currentStatus = STATUS_SAVING;

					this.emailSync();
					axios.post('/users/save', {UserLogin: this.user, Contact: this.contact}
					)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_INITIAL;
							this.$notify({
								title: 'Success',
								message: 'Profile has been saved',
								type: 'success',
								duration: 1500,
								showClose: false
							});
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
					});
				} else {
					//scroll to errors
	                let self = this;
                    setTimeout(() => { var element = document.querySelector(".is-error"); self.$scrollTo(element); }, 250);
				}
			},
	        displayPopup (message) {
                this.$alert(message, 'Profile Error', {
                    confirmButtonText: 'OK',
                });
            },
		},
		mounted() {
			this.reset(false);
			this.getProfileData();
		},
	}
</script>


<style>
	.avatar {
		width: 90px;
		height: 90px;
		background: #FFFFFF center center no-repeat;
		background-size: cover;
		cursor: pointer;
		border: 4px solid #d0d0d0;
	}
	.avatar.success_upload {
		border: 4px solid #28a745;
	}
	.avatar.failed_upload {
        border: 4px solid #dc3545;
    }
	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 90px;
		position: absolute;
		cursor: pointer;
		left:0;
	}
	.card {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.card-header.details {
		margin: -20px -13px 20px -13px;
	}
	.badge {
		cursor: pointer;
		margin-left: 10px;
	}
	.modalFooter {
	    position: fixed;
	    bottom: 0;
	    width: 100%;
	    margin: 10px 0px;
	}
	.newLoginText {
		font-size: 12px;
		color: #606266;
		margin: 7px 7px 15px;

	}
	.showpublic {
		margin-top: 29px;
	    font-size: 10px;
        color: #606266;
	}
    .select-organization {
		width: 100%;
    }
	#app #profile .el-select {
		width: 100%;
	}
	#app .el-form-item.postalCode {
		width: 50%;
	}
	#app #profile .el-form-item {
		margin-bottom: 10px;
	}
	#app #profile .el-form--label-top .el-form-item__label {
		font-size: 12px;
		line-height: 15px;
	}
	#app #profile .el-form-item__content {
		line-height: 20px;
	}
	#app #profile .el-form-item.is-error {
		margin-bottom: 16px;
	}
	#profile .col-8 {
		padding: 0;
	}
    #profile .avatar {
        width: 90px;
        height: 90px;
        background: #fff 50% no-repeat;
        background-size: cover;
        cursor: pointer;
        border: 4px solid #d0d0d0;
    }
    #profile  .el-input--small .el-input__inner {
        height: 32px;
        line-height: 32px;
    }
</style>
